import { DefaultLayout } from '@c/layouts';
import CookiesPolicyPage from '@c/CookiesPolicyPage';
import SEO from '@c/SEO';
import React from 'react';

const CookiesPolicy = () => {
  return (
    <>
      <SEO
        title="Cookie Policy"
        description="Learn how GearFocus uses cookies to improve your browsing experience on our camera gear marketplace."
      />
      <CookiesPolicyPage />
    </>
  );
};

CookiesPolicy.getLayout = function getLayout(page: React.ReactElement) {
  return <DefaultLayout>{page}</DefaultLayout>;
};

export default CookiesPolicy;
